<script lang="ts">
  import * as _ from "lodash";
  import SellSheetProductSort from "@distributor/svelte/SellSheet/Components/ProductsSort.svelte";
  import SellSheetProducts from "@distributor/svelte/SellSheet/Components/Products.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import type { DistributorSellSheet } from "@shared/types/SellSheet";
  import Flash from "@shared/services/flashv2.js";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FormErrors from "@shared/svelte/Components/FormErrors.svelte";
  export let sellSheet: DistributorSellSheet;
  export let page;
  export let mobileMode: boolean;
  import LoadingSpinner from "@shared/svelte/Components/LoadingSpinner.svelte";

  let showAddProductsModal = false;
  let errors;

  const editOrder = function () {
    _.map(sellSheet.product_lines, function (pl) {
      pl.editing = false;
    });
    page.sortMode = true;
  };

  const cancelEditOrder = function () {
    page.loading = true;
    window["stateService"].reload();
  };

  const updatePositions = function () {
    let result = [];
    let index = 0;
    _.each(page.sortOrder, function (p) {
      result.push({ position: index, id: parseInt(p.id) });
      index++;
    });
    return result;
  };

  const saveOrder = async function () {
    if (!page.sortOrder) {
      return;
    }
    page.sortMode = false;
    page.loading = true;
    try {
      let res = await HttpPromise({
        method: "PUT",
        url: `/api/distributor/sell_sheets/${sellSheet.id}`,
        data: {
          sell_sheet: {
            sell_sheet_product_lines_attributes: updatePositions(),
          },
        },
      });
      Flash.now({ message: `Ordering updated!`, type: "success" });
      sellSheet = res;
      page.loading = false;
    } catch (error) {
      errors = { messages: error };
      page.loading = false;
    }
  };

  const addProducts = function () {
    showAddProductsModal = true;
    page.sortMode = false;
  };
</script>

<style>
  .fake-fizz-button {
    border-radius: 4px;
    border: 1px solid #bfbfbf;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding: 0.5rem 1rem;
    color: #052c48;
    background-color: #ffffff;
    cursor: pointer;
    white-space: nowrap;
    text-align: center;
  }

  .fake-fizz-button-small {
    font-size: 0.75rem;
    line-height: 1.125rem;
    padding: 0.25rem 0.5rem;
  }
</style>

<FormErrors {errors} />
<div class="margin-bottom--small">
  <div class="grid-row padding-bottom--smallest">
    <div class="grid-col c12-12">
      <div
        class="cart__item-header align-left padding--small padding--smaller--md background-white"
        style="height: 65px;"
      >
        <div class="grid-row">
          <div class="grid-col c12-12">
            <span
              class="default-body--regular default-subheader--regular--md padding-top--smaller--md padding-left--smaller--md vertical-align-middle float-left"
              >Products</span
            >
            <span
              class="sell-sheet-button-wrapper float-right vertical-align-middle padding-top--smaller--md padding-top--none--lg padding-right--smaller--md"
            >
              {#if !page.sortMode}
                <button
                  class:fake-fizz-button-small={mobileMode}
                  disabled={page.loading}
                  style="display: inline;"
                  class="fake-fizz-button button--secondary"
                  on:click={addProducts}
                >
                  Add Products
                </button>
              {/if}
              {#if !page.sortMode && sellSheet.product_lines.length}
                <button
                  class:fake-fizz-button-small={mobileMode}
                  disabled={page.loading}
                  style="display: inline;"
                  class="fake-fizz-button button--secondary"
                  on:click={editOrder}
                >
                  <span class="vertical-align-middle"
                    ><Icon extraStyles="display: inline;" type="Sort" /></span
                  >
                  Sort Order
                </button>
              {/if}
              {#if page.sortMode}
                <button
                  class:fake-fizz-button-small={mobileMode}
                  style="display: inline;"
                  class="fake-fizz-button button--primary margin-left--smallest"
                  on:click={saveOrder}
                >
                  Save Order
                </button>
                <button
                  class:fake-fizz-button-small={mobileMode}
                  style="display: inline;"
                  class="fake-fizz-button button--secondary margin-left--smallest"
                  on:click={cancelEditOrder}
                >
                  Cancel
                </button>
              {/if}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  {#if sellSheet.product_lines.length == 0}
    <div style="margin-top: -20px;">
      <div class="grid-row">
        <div class="grid place-items-center gap-16">
          <div class="margin-top--medium" style="height: 90px;"
            ><img
              alt="add products"
              src={window["$rootScope"].C.IMAGE_PATHS["product_review.svg"]}
            /></div
          >
          <div class="s3 color-grayDark padding-top--medium padding-bottom--3"
            >Search & Add Products to your Sheet</div
          >
        </div>
      </div>
    </div>
  {/if}

  {#if page.loading}
    <div class="tile fizz-styles">
      <LoadingSpinner />
    </div>
  {:else if page.sortMode}
    <SellSheetProductSort {sellSheet} bind:page />
  {:else}
    <SellSheetProducts bind:sellSheet bind:page {mobileMode} bind:showAddProductsModal />
  {/if}
</div>
